import { gqlClient } from '../../components/AppProvider';
import { AccountOrder, CompanyVerificationStatus, MutationStatusCode } from '../../gql-types.generated';
import { queryAllTenantAccounts } from '../../gql/QueryAllTenantAccounts';
import { mutationDeleteTenantAccount } from '../../gql/MutationDeleteTenantAccount';
import { AppThunk } from '../../store';
import { decrementRequestsInFlight, incrementRequestsInFlight } from '../app/AppSlice';
import { fetchAllTenantsStart, fetchError, fetchAllTenantsSuccess, captureDeleteStatus, captureDeleteError } from './AllTenantsSlice';

export const fetchAllTenants =
  (orderBy?: AccountOrder, after?: string, queryString?: string, status?: CompanyVerificationStatus[]): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    if (!after) {
      dispatch(fetchAllTenantsStart());
    }

    try {
      const result = await queryAllTenantAccounts(gqlClient, {
        first: 25,
        after,
        orderBy,
        queryString,
        status,
      });

      if (!result) {
        dispatch(decrementRequestsInFlight());
        return;
      }

      dispatch(fetchAllTenantsSuccess(result));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(fetchError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };

export const deleteTenant =
  (tenantId: string): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    dispatch(captureDeleteError(undefined));

    try {
      const status = await mutationDeleteTenantAccount(gqlClient, tenantId);
      if (status) {
        if (status.code === MutationStatusCode.Error) {
          dispatch(captureDeleteError({ message: status.message } as Error));
        }
        dispatch(captureDeleteStatus(status));
      }
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(captureDeleteError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };
